"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmPostDrawer = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _shared_1 = require("../_shared");
const _routeSearch_1 = __importStar(require("@front/pages/settings/social-media-gate/_routeSearch"));
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.drawerOpen && x.selectedPost, (0, fast_element_1.html) `
<div class="cs-overlay" @click="${x => x.close()}"></div>
<aside class="cs-drawer">
    <div class="cs-drawer-header">
        <div>
            <h5>${x => { var _a; return (_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.title; }}</h5>
            <span class="${x => { var _a; return 'status-badge status-' + (((_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.status) || ''); }}">
                ${x => { var _a; return x.getStatusLabel(((_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.status) || ''); }}
            </span>
        </div>
        <button @click="${x => x.close()}">&times;</button>
    </div>

    <div class="cs-drawer-tabs">
        <button class="${x => x.drawerTab === 'preview' ? 'active' : ''}" @click="${x => x.setTab('preview')}">${'socialMediaPlan.drawer.preview'.t()}</button>
        <button class="${x => x.drawerTab === 'ai' ? 'active' : ''}" @click="${x => x.setTab('ai')}">${'socialMediaPlan.drawer.ai'.t()}</button>
    </div>

    ${(0, fast_element_1.when)(x => x.drawerTab === 'preview', (0, fast_element_1.html) `
    <div class="cs-drawer-body">
        <div class="cs-drawer-meta">
            <div><span>${'socialMediaPlan.drawer.platforms'.t()}</span><strong>${x => { var _a, _b; return (_b = (_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.platforms) === null || _b === void 0 ? void 0 : _b.join(', '); }}</strong></div>
            <div><span>${'socialMediaPlan.drawer.date'.t()}</span><strong>${x => { var _a; return x.formatDate((_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.scheduledAt); }}</strong></div>
            <div><span>${'socialMediaPlan.drawer.type'.t()}</span><strong>${x => { var _a, _b; return ((_b = (_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.brief) === null || _b === void 0 ? void 0 : _b.contentType) || '-'; }}</strong></div>
        </div>
        ${(0, fast_element_1.repeat)(x => { var _a; return ((_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.platforms) || []; }, (0, fast_element_1.html) `
        <div class="cs-platform-preview">
            <div class="cs-pf-header" :innerHTML="${(pid, c) => c.parent.pfBadgeHtml(pid, 26) + ' ' + c.parent.getPlatformLabel(pid)}"></div>
            ${(0, fast_element_1.when)((pid, c) => !!c.parent.getPostContentImageUrl(c.parent.selectedPost, pid), (0, fast_element_1.html) `
            <div class="cs-pf-img-wrap"><img src="${(pid, c) => c.parent.getPostContentImageUrl(c.parent.selectedPost, pid)}" class="cs-pf-img" alt=""></div>
            `)}
            <div class="cs-pf-text">${(pid, c) => c.parent.getPostContent(c.parent.selectedPost, pid).text}</div>
            <div class="cs-pf-hashtags">${(pid, c) => (c.parent.getPostContent(c.parent.selectedPost, pid).hashtags || []).join(' ')}</div>
            ${(0, fast_element_1.when)((pid, c) => { var _a, _b; return !!((_b = (_a = c.parent.selectedPost) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.find((e) => e.platform === pid)); }, (0, fast_element_1.html) `
            <div class="cs-pf-error"><i class="simple-icon-exclamation"></i> ${(pid, c) => { var _a, _b, _c; return (_c = (_b = (_a = c.parent.selectedPost) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.find((e) => e.platform === pid)) === null || _c === void 0 ? void 0 : _c.error; }}</div>
            `)}
        </div>
        `)}
    </div>
    `)}

    ${(0, fast_element_1.when)(x => x.drawerTab === 'ai', (0, fast_element_1.html) `
    <div class="cs-drawer-body">
        ${(0, fast_element_1.repeat)(x => { var _a; return ((_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.platforms) || []; }, (0, fast_element_1.html) `
        <div class="cs-best-time">
            <strong>${(pid, c) => c.parent.getPlatformLabel(pid)}:</strong>
            <span>${(pid, c) => c.parent.getPlatformBestTime(pid)}</span>
        </div>
        `)}
    </div>
    `)}

    <div class="cs-drawer-footer">
        ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.selectedPost) === null || _a === void 0 ? void 0 : _a.status) !== 'published'; }, (0, fast_element_1.html) `
        <button class="btn-cs-publish" ?disabled="${x => x.publishing}" @click="${x => x.publishPost()}">
            ${(0, fast_element_1.when)(x => x.publishing, (0, fast_element_1.html) `<app-loader block="true" width="12" height="12"></app-loader>`)}
            ${(0, fast_element_1.when)(x => !x.publishing, (0, fast_element_1.html) `<i class="simple-icon-rocket"></i>`)}
            ${'socialMediaPlan.post.publish'.t()}
        </button>
        `)}
        <button class="btn-cs-primary" @click="${x => x.editPost()}"><i class="simple-icon-pencil"></i> ${'socialMediaPlan.edit'.t()}</button>
        <button class="btn-cs-outline" @click="${(x, c) => x.duplicatePost(c.event)}"><i class="iconsminds-duplicate-layer"></i></button>
        <button class="btn-cs-danger" @click="${x => x.deletePost()}"><i class="simple-icon-trash"></i></button>
    </div>
</aside>
`)}
`;
require("./styles/layout.scss");
const styles = T.css `@charset "UTF-8";
.cs-card {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(24, 24, 56, 0.06);
}

.btn-cs-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #5B3DF6;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.12s;
}
.btn-cs-primary:hover {
  opacity: 0.92;
}
.btn-cs-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-cs-outline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #3A3F49;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s;
}
.btn-cs-outline:hover {
  background: #EFF1F4;
}

.btn-cs-danger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #DC2626;
  border: 1px solid #f3c8c8;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-cs-danger:hover {
  background: #FDEAEA;
}

.btn-cs-publish {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #16A34A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}
.btn-cs-publish:hover {
  opacity: 0.9;
}
.btn-cs-publish:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cs-badge {
  font-size: 0.7rem;
  font-weight: 700;
  background: #EFF1F4;
  color: #6B7180;
  border-radius: 20px;
  padding: 2px 8px;
}

.cs-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.cs-page-header h2 {
  font-size: 1.25rem;
  font-weight: 800;
  margin: 0 0 4px;
}
.cs-page-header .cs-label-primary {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5B3DF6;
  margin-bottom: 2px;
}
.cs-page-header .cs-desc {
  font-size: 0.84rem;
  color: #6B7180;
  max-width: 560px;
  margin: 0;
}

.cs-stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.cs-stat-card {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cs-stat-card .cs-stat-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #6B7180;
}
.cs-stat-card .cs-stat-value {
  font-size: 1.6rem;
  font-weight: 800;
  color: #16181D;
}
.cs-stat-card .cs-stat-value.warn {
  color: #B45309;
}
.cs-stat-card .cs-stat-value.success {
  color: #16A34A;
}

.cs-studio-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #EFF1F4;
  margin-bottom: 16px;
}
.cs-studio-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  color: #9199A8;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}
.cs-studio-tabs button:hover {
  color: #3A3F49;
}
.cs-studio-tabs button.active {
  color: #5B3DF6;
  border-bottom-color: #5B3DF6;
}

.cs-library-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.cs-library-header .cs-library-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
}

.cs-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.cs-filters .cs-search-wrap {
  position: relative;
  flex: 1 1 200px;
}
.cs-filters .cs-search-wrap i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9199A8;
  font-size: 0.8rem;
}
.cs-filters .cs-search-wrap input {
  width: 100%;
  padding: 7px 10px 7px 30px;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  font-size: 0.82rem;
}
.cs-filters .cs-filter-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.cs-filters .cs-filter-btns button {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 999px;
  padding: 5px 14px;
  font-size: 0.74rem;
  font-weight: 600;
  color: #6B7180;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.cs-filters .cs-filter-btns button:hover {
  background: #EFF1F4;
}
.cs-filters .cs-filter-btns button.active {
  background: #F1EEFF;
  color: #5B3DF6;
  border-color: #E1D9FF;
}

.cs-posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
}

.cs-post-card {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 14px;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.12s;
}
.cs-post-card:hover {
  box-shadow: 0 10px 28px rgba(24, 24, 56, 0.1);
  border-color: #C4C9D2;
  transform: translateY(-2px);
}
.cs-post-card .cs-post-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 4px;
}
.cs-post-card .cs-post-title {
  font-weight: 700;
  font-size: 0.88rem;
  margin-bottom: 4px;
  color: #16181D;
}
.cs-post-card .cs-post-excerpt {
  font-size: 0.76rem;
  color: #6B7180;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 32px;
  margin-bottom: 10px;
}
.cs-post-card .cs-post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cs-post-card .cs-post-date {
  font-size: 0.7rem;
  color: #9199A8;
}
.cs-post-card .cs-post-actions {
  display: flex;
  gap: 4px;
}
.cs-post-card .cs-post-actions button {
  background: none;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 3px 7px;
  font-size: 0.7rem;
  cursor: pointer;
  color: #6B7180;
  transition: background 0.1s;
}
.cs-post-card .cs-post-actions button:hover {
  background: #EFF1F4;
}
.cs-post-card .cs-post-actions button.danger {
  color: #DC2626;
  border-color: #f3c8c8;
}
.cs-post-card .cs-post-actions button.danger:hover {
  background: #FDEAEA;
}

.cs-platform-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}

.cs-platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 6px 6px 0;
}
.cs-platform-chip:hover {
  border-color: #C4C9D2;
}
.cs-platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}

.cs-empty {
  text-align: center;
  padding: 48px 20px;
}
.cs-empty .cs-empty-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #F1EEFF;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 1.4rem;
}
.cs-empty strong {
  display: block;
  font-size: 1rem;
  color: #22252C;
  margin-bottom: 6px;
}
.cs-empty p {
  font-size: 0.82rem;
  color: #6B7180;
  max-width: 360px;
  margin: 0 auto 14px;
}

.cs-ai-assistant {
  background: linear-gradient(135deg, #F1EEFF 0%, #fff 100%);
  border-color: #E1D9FF;
}
.cs-ai-assistant .cs-ai-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}
.cs-ai-assistant .cs-ai-header .cs-ai-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #F1EEFF;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  flex-shrink: 0;
}
.cs-ai-assistant .cs-ai-header strong {
  font-size: 0.94rem;
  font-weight: 700;
}
.cs-ai-assistant .cs-ai-header p {
  font-size: 0.78rem;
  color: #6B7180;
  margin: 2px 0 0;
}
.cs-ai-assistant .cs-ai-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 12px;
}
.cs-ai-assistant .cs-ai-presets button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #E1D9FF;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 0.76rem;
  font-weight: 600;
  color: #5B3DF6;
  cursor: pointer;
  transition: background 0.12s;
}
.cs-ai-assistant .cs-ai-presets button:hover {
  background: #F1EEFF;
}
.cs-ai-assistant .cs-ai-input-row {
  display: flex;
  gap: 8px;
}
.cs-ai-assistant .cs-ai-input-row input {
  flex: 1;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.84rem;
}
.cs-ai-assistant .cs-ai-response {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  margin-top: 14px;
  box-shadow: 0 10px 28px rgba(24, 24, 56, 0.1);
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #EFF1F4;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header span {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  gap: 7px;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: #9199A8;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-text {
  padding: 14px;
  font-size: 0.84rem;
  white-space: pre-wrap;
  color: #22252C;
  min-height: 40px;
}

.cs-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 16, 24, 0.4);
  z-index: 200;
}

.cs-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 440px;
  height: 100vh;
  background: #fff;
  box-shadow: var(--cs-shadow-lg);
  z-index: 210;
  display: flex;
  flex-direction: column;
}
@media (max-width: 500px) {
  .cs-drawer {
    width: 100vw;
  }
}
.cs-drawer .cs-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #EFF1F4;
}
.cs-drawer .cs-drawer-header h5 {
  margin: 0 0 4px;
  font-size: 0.96rem;
  font-weight: 700;
}
.cs-drawer .cs-drawer-header button {
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  color: #9199A8;
}
.cs-drawer .cs-drawer-tabs {
  display: flex;
  border-bottom: 1px solid #EFF1F4;
}
.cs-drawer .cs-drawer-tabs button {
  flex: 1;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 14px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #9199A8;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}
.cs-drawer .cs-drawer-tabs button.active {
  color: #5B3DF6;
  border-bottom-color: #5B3DF6;
}
.cs-drawer .cs-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 16px;
}
.cs-drawer .cs-drawer-meta {
  background: #EFF1F4;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}
.cs-drawer .cs-drawer-meta div {
  text-align: center;
}
.cs-drawer .cs-drawer-meta span {
  display: block;
  font-size: 0.68rem;
  color: #6B7180;
  margin-bottom: 2px;
}
.cs-drawer .cs-drawer-meta strong {
  font-size: 0.78rem;
}
.cs-drawer .cs-platform-preview {
  margin-bottom: 12px;
}
.cs-drawer .cs-pf-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.cs-drawer .cs-pf-text {
  font-size: 0.82rem;
  color: #3A3F49;
  white-space: pre-wrap;
  padding: 8px;
  background: #EFF1F4;
  border-radius: 8px;
}
.cs-drawer .cs-pf-hashtags {
  font-size: 0.76rem;
  color: #2563EB;
  margin-top: 4px;
}
.cs-drawer .cs-best-time {
  display: flex;
  gap: 8px;
  font-size: 0.82rem;
  margin-bottom: 8px;
}
.cs-drawer .cs-drawer-footer {
  border-top: 1px solid #EFF1F4;
  padding: 10px 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cs-creator-overlay {
  position: fixed;
  inset: 0;
  background: #F6F6FA;
  z-index: 300;
  display: flex;
  flex-direction: column;
}

.cs-creator-topbar {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #EFF1F4;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.cs-creator-topbar .cs-creator-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cs-creator-topbar .cs-creator-title .cs-creator-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(135deg, #5B3DF6, #8B6FF8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
.cs-creator-topbar .cs-creator-title strong {
  font-size: 0.96rem;
  font-weight: 700;
}
.cs-creator-topbar .cs-creator-title small {
  display: block;
  font-size: 0.72rem;
  color: #9199A8;
}
.cs-creator-topbar .cs-creator-steps {
  display: flex;
  align-items: center;
}

.cs-creator-body {
  flex: 1;
  overflow-y: auto;
  padding: 28px 20px 40px;
}

.cs-creator-step {
  max-width: 1100px;
  margin: 0 auto;
}

.cs-creator-footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #EFF1F4;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cs-creator-footer .cs-creator-footer-right {
  display: flex;
  gap: 10px;
}

.cs-field-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #3A3F49;
  margin-bottom: 6px;
}
.cs-field-label.tip {
  color: #5B3DF6;
}

.cs-generate-gate {
  text-align: center;
  padding: 48px 20px;
}
.cs-generate-gate i {
  font-size: 2.4rem;
  color: #5B3DF6;
}
.cs-generate-gate h5 {
  font-weight: 700;
  margin: 14px 0 6px;
}
.cs-generate-gate p {
  font-size: 0.82rem;
  color: #6B7180;
  margin-bottom: 18px;
}

.cs-preview-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-bottom: 16px;
}
.cs-preview-tabs button {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  background: #fff;
  padding: 7px 13px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6B7180;
  cursor: pointer;
  transition: all 0.12s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cs-preview-tabs button.active {
  border-color: #5B3DF6;
  background: #F1EEFF;
  color: #5B3DF6;
}

.cs-platform-editor {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  align-items: flex-start;
}
@media (max-width: 768px) {
  .cs-platform-editor {
    grid-template-columns: 1fr;
  }
}

.cs-platform-editor-form label {
  display: block;
  margin-bottom: 6px;
}
.cs-platform-editor-form textarea {
  width: 100%;
}

.cs-image-gen-card {
  border-color: #E1D9FF !important;
  background: #F1EEFF !important;
}

.cs-generated-image {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E5EA;
}
.cs-generated-image img {
  display: block;
  width: 100%;
  max-height: 340px;
  object-fit: cover;
}

.cs-goal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

.cs-goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.cs-goal-card:hover {
  border-color: #C4C9D2;
  background: rgba(91, 61, 246, 0.04);
}
.cs-goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.cs-goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
  display: block;
}
.cs-goal-card span {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 6px;
}

.cs-tip-card {
  background: #F1EEFF !important;
  border-color: #E1D9FF !important;
}
.cs-tip-card p {
  font-size: 0.78rem;
  color: #6B7180;
  margin: 0;
}

.cs-action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  margin-top: 8px;
}

.cs-recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.cs-recap-row:last-child {
  border-bottom: none;
}
.cs-recap-row span {
  color: #6B7180;
  white-space: nowrap;
  flex-shrink: 0;
  padding-right: 8px;
}
.cs-recap-row strong {
  text-align: right;
  word-break: break-word;
}

.cs-calendar-section, .cs-history-section {
  min-height: 300px;
}

.cs-log-line {
  font-size: 0.8rem;
  font-family: "Courier New", monospace;
  padding: 2px 0;
  color: #1a6fa8;
}

.btn-generate app-loader, .btn-cs-primary app-loader, .btn-cs-outline app-loader, .btn-cs-publish app-loader, .btn-cs-danger app-loader {
  position: static !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  width: 14px !important;
  height: 14px !important;
}

.pc-card {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 20px;
}

.pc-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #3A3F49;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pc-hint {
  font-size: 0.72rem;
  color: #9199A8;
  margin-top: 4px;
}

.btn-generate {
  background: linear-gradient(135deg, #5B3DF6, #8B6FF8);
  border: none;
  color: #fff;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 8px;
  font-size: 0.95rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 20px rgba(91, 61, 246, 0.28);
  transition: transform 0.12s, box-shadow 0.12s;
}
.btn-generate:hover {
  color: #fff;
  opacity: 0.96;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(91, 61, 246, 0.34);
}
.btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 8px 8px 0;
}
.platform-chip:hover {
  border-color: #C4C9D2;
}
.platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.platform-chip .chip-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #22252C;
}

.goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.goal-card:hover {
  border-color: #C4C9D2;
}
.goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
  display: block;
}
.goal-card .goal-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 4px;
}

.native-preview {
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.09);
  background: #fff;
  box-shadow: 0 8px 32px rgba(24, 24, 56, 0.13), 0 1px 3px rgba(0, 0, 0, 0.06);
  max-width: 320px;
}

.np-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.np-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5B3DF6 0%, #8B6FF8 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.72rem;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(91, 61, 246, 0.35);
}

.np-name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
}

.np-handle {
  font-size: 0.68rem;
  color: #9199A8;
  line-height: 1.2;
}

.np-more {
  margin-left: auto;
  color: #C4C9D2;
  font-size: 1.1rem;
  line-height: 1;
}

.np-media {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  color: #C4C9D2;
  font-size: 0.72rem;
  min-height: 180px;
  background: repeating-linear-gradient(135deg, #f5f6f8 0px, #f5f6f8 10px, #eceef1 10px, #eceef1 20px);
}
.np-media i {
  font-size: 2rem;
  opacity: 0.5;
}
.np-media img {
  width: 100%;
  display: block;
  max-height: 260px;
  object-fit: cover;
}

.np-caption {
  padding: 12px 14px 6px;
  font-size: 0.82rem;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  color: #1a1d23;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.np-hashtags {
  padding: 0 14px 12px;
  font-size: 0.76rem;
  color: #4267b2;
  font-weight: 500;
  line-height: 1.5;
}

.np-footer {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  color: #6B7180;
}
.np-footer span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: color 0.12s;
}
.np-footer span:hover {
  color: #5B3DF6;
}

.pv-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: 2px solid #EFF1F4;
}

.pv-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 6px 14px 6px 8px;
  cursor: pointer;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6B7180;
  transition: all 0.15s;
}
.pv-tab:hover {
  border-color: #C4C9D2;
  background: #EFF1F4;
}
.pv-tab.active {
  border-color: #5B3DF6;
  background: #F1EEFF;
  color: #5B3DF6;
  box-shadow: 0 0 0 3px rgba(91, 61, 246, 0.1);
}
.pv-tab .pv-tab-warn {
  color: #DC2626;
  margin-left: 2px;
}

.pv-pane {
  display: none;
}

.pv-pane.active {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 28px;
  align-items: flex-start;
}
@media (max-width: 900px) {
  .pv-pane.active {
    grid-template-columns: 1fr;
  }
}

.pv-preview-col {
  position: sticky;
  top: 16px;
}

.pv-editor {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.pv-editor .pv-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.pv-editor .pv-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pv-editor .pv-field-header label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #3A3F49;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.pv-editor .pv-field-header .pv-field-meta {
  font-size: 0.7rem;
  color: #9199A8;
}
.pv-editor textarea {
  font-size: 0.88rem;
  line-height: 1.7;
  color: #16181D;
  width: 100%;
  resize: vertical;
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  min-height: 130px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pv-editor textarea:focus {
  border-color: #5B3DF6;
  box-shadow: 0 0 0 3px #F1EEFF;
  outline: none;
}
.pv-editor input[type=text] {
  font-size: 0.84rem;
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 12px;
  width: 100%;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pv-editor input[type=text]:focus {
  border-color: #5B3DF6;
  box-shadow: 0 0 0 3px #F1EEFF;
  outline: none;
}
.pv-editor .pv-hashtag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 2px;
}
.pv-editor .pv-hashtag-chips span {
  display: inline-block;
  background: #EAF1FE;
  color: #2563EB;
  font-size: 0.73rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 10px;
}

.pv-counter {
  font-size: 0.72rem;
  color: #9199A8;
  text-align: right;
}
.pv-counter.over {
  color: #DC2626;
  font-weight: 700;
}

.pv-limit-track {
  height: 4px;
  border-radius: 4px;
  background: #EFF1F4;
  overflow: hidden;
}

.pv-limit-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.2s, background 0.2s;
  background: #16A34A;
}
.pv-limit-fill.warn {
  background: #B45309;
}
.pv-limit-fill.over {
  background: #DC2626;
}

.pv-insight-card {
  background: linear-gradient(135deg, #F1EEFF, #fff);
  border: 1px solid #E1D9FF;
  border-radius: 8px;
  padding: 12px 14px;
}

.pv-insight-title {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 800;
  color: #5B3DF6;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.gen-img-card {
  border-color: #E1D9FF !important;
  background: #F1EEFF !important;
}

.gen-img-preview {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E5EA;
  background: #EFF1F4;
  position: relative;
  line-height: 0;
}
.gen-img-preview img {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: cover;
}
.gen-img-preview .gen-img-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 0.64rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 9px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  backdrop-filter: blur(4px);
}

.engagement-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 10px;
}

.engagement-Wysoki {
  background: #E9F9EF;
  color: #16A34A;
}

.engagement-Średni {
  background: #FDF3E3;
  color: #B45309;
}

.engagement-Niski {
  background: #FDEAEA;
  color: #DC2626;
}

.schedule-choice {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.schedule-choice:hover {
  border-color: #C4C9D2;
}
.schedule-choice.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.schedule-choice i {
  font-size: 1.25rem;
  color: #5B3DF6;
  display: block;
}
.schedule-choice .sc-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #22252C;
  margin: 6px 0 2px;
}
.schedule-choice .sc-desc {
  font-size: 0.7rem;
  color: #9199A8;
}

.recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.recap-row:last-child {
  border-bottom: none;
}
.recap-row span {
  color: #6B7180;
}
.recap-row strong {
  text-align: right;
}

.cs-pf-img-wrap {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
  max-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.cs-pf-img {
  width: 100%;
  max-height: 180px;
  object-fit: cover;
  display: block;
}

.cs-pf-error {
  font-size: 0.74rem;
  color: #dc2626;
  margin-top: 5px;
  padding: 5px 8px;
  background: #fef2f2;
  border-left: 3px solid #dc2626;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  gap: 5px;
}
.cs-pf-error i {
  flex-shrink: 0;
  margin-top: 1px;
}`;
const shadowOptions = { "mode": "open" };
let SmPostDrawer = class SmPostDrawer extends client_1.RWSViewComponent {
    constructor(routeSearchService) {
        super();
        this.routeSearchService = routeSearchService;
        this.selectedPost = null;
        this.drawerOpen = false;
        this.drawerTab = 'preview';
        this.publishing = false;
        this.proxy = false;
    }
    setTab(tab) { this.drawerTab = tab; }
    close() { this.$emit('drawer-closed', {}); }
    editPost() { this.$emit('edit-post', { post: this.selectedPost }); }
    duplicatePost(e) {
        e.stopPropagation();
        this.$emit('duplicate-post', { post: this.selectedPost });
    }
    deletePost() { this.$emit('delete-post', { post: this.selectedPost }); }
    async publishPost() {
        var _a, _b, _c;
        if (!this.selectedPost)
            return;
        this.publishing = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('social-media-post.publish', { id: String(this.selectedPost.id) }, {}, 'POST')
                : await this.apiService.back.post('social-media-post.publish', {}, { routeParams: { id: String(this.selectedPost.id) } });
            if (resp === null || resp === void 0 ? void 0 : resp.success) {
                const succeeded = ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.results.filter(r => r.success)) || [];
                const failed = ((_b = resp.data) === null || _b === void 0 ? void 0 : _b.results.filter(r => !r.success)) || [];
                if (succeeded.length) {
                    const urls = succeeded.map(r => r.postUrl).filter(Boolean).join(', ');
                    this.notifyService.notify('socialMediaPlan.post.publishedOn'.t() + ' ' + succeeded.map(r => r.platform).join(', ') + (urls ? ': ' + urls : ''), 'info');
                }
                if (failed.length) {
                    this.notifyService.notify('socialMediaPlan.post.publishFailed'.t() + ': ' + failed.map(r => r.platform + ' — ' + r.error).join('; '), 'error');
                }
                this.$emit('publish-post', { post: this.selectedPost, results: (_c = resp.data) === null || _c === void 0 ? void 0 : _c.results });
            }
            else {
                this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.post.publishError'.t(), 'error');
            }
        }
        catch (_d) {
            this.notifyService.notify('socialMediaPlan.post.publishError'.t(), 'error');
        }
        finally {
            this.publishing = false;
        }
    }
    getPostContent(post, pid) {
        var _a;
        return ((_a = post === null || post === void 0 ? void 0 : post.content) === null || _a === void 0 ? void 0 : _a[pid]) || { text: '', hashtags: [] };
    }
    getPostContentImageUrl(post, pid) {
        return (0, _shared_1.getPostImageUrl)(post, pid);
    }
    getPlatformLabel(pid) { return (0, _shared_1.getPlatformLabel)(pid); }
    getPlatformBestTime(pid) { return (0, _shared_1.getPlatformBestTime)(pid); }
    getStatusLabel(s) { return (0, _shared_1.getStatusLabel)(s); }
    getStatusColor(s) { return (0, _shared_1.getStatusColor)(s); }
    formatDate(d) { return (0, _shared_1.formatDate)(d); }
    pfBadgeHtml(pid, size = 26) { return (0, _shared_1.pfBadge)(pid, size); }
};
exports.SmPostDrawer = SmPostDrawer;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof _shared_1.IFrontPost !== "undefined" && _shared_1.IFrontPost) === "function" ? _b : Object)
], SmPostDrawer.prototype, "selectedPost", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmPostDrawer.prototype, "drawerOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmPostDrawer.prototype, "drawerTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmPostDrawer.prototype, "publishing", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SmPostDrawer.prototype, "proxy", void 0);
exports.SmPostDrawer = SmPostDrawer = __decorate([
    (0, client_1.RWSView)('sm-post-drawer', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(_routeSearch_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof _routeSearch_1.RouteSearchServiceInstance !== "undefined" && _routeSearch_1.RouteSearchServiceInstance) === "function" ? _a : Object])
], SmPostDrawer);
SmPostDrawer.defineComponent();
